package com.downdogapp.client.views

import com.downdogapp.*
import com.downdogapp.Color.Companion.BLACK
import com.downdogapp.Display.INLINE_BLOCK
import com.downdogapp.Position.ABSOLUTE
import com.downdogapp.Size.Companion.percent
import com.downdogapp.Size.Companion.px
import com.downdogapp.Size.INHERIT
import com.downdogapp.TextAlign.CENTER
import com.downdogapp.client.controllers.LoadingViewController
import com.downdogapp.client.singleton.App
import com.downdogapp.client.widget.*
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLSpanElement
import kotlin.math.floor

actual fun createLoadingView(controller: LoadingViewController,
                             initialMessage: String,
                             initialProportion: Double): LoadingView = object : TopLevelView(), LoadingView {

  private var progressView: HTMLDivElement
  private var unprogressView: HTMLDivElement
  private var messageView: HTMLSpanElement
  private var percentView: HTMLSpanElement

  private var loadedProportion = initialProportion

  override val root = controllerView {

    bg = background(image = App.getBackgroundImage())

    fg = foreground {
      centerInParent {
        width = px(640)

        div {
          width = INHERIT
          textAlign = CENTER

          messageView = label(fontSize = 38) {
            text = initialMessage
            textShadow = TextShadow.shadow(
              horizontal = px(0),
              vertical = px(2),
              blur = px(4),
              color = BLACK
            )
          }
        }

        div {
          width = INHERIT
          marginTop = px(30)
          textAlign = CENTER

          percentView = label(fontSize = 28) {
            textShadow = TextShadow.shadow(
              horizontal = px(0),
              vertical = px(2),
              blur = px(4),
              color = BLACK
            )
          }
        }
      }

      div {
        position = ABSOLUTE
        bottom = px(0)
        left = px(0)
        width = percent(100)
        height = px(15)

        progressView = div {
          height = INHERIT
          width = percent(0)
          display = INLINE_BLOCK

          bgColor = Color.downDogBlue(0.8)
        }

        unprogressView = div {
          height = INHERIT
          width = percent(100)
          display = INLINE_BLOCK

          bgColor = Color.grey(0.4)
        }
      }
    }
  }

  override fun setMessage(message: String) {
    messageView.text = message
  }

  override fun setLoadedProportion(proportion: Double) {
    val startValue = loadedProportion
    loadedProportion = proportion
    Animation.animate(
      animationLength = LoadingViewController.animationDuration,
      onStep = {
        val progress = startValue + (proportion - startValue) * it
        progressView.width = percent(100 * progress)
        unprogressView.width = percent(100 * (1 - progress))
        percentView.text = "${minOf(floor(100 * progress), 99.0)}%"
        true
      }
    )
  }
}
